import React, { useCallback, useEffect, useState } from "react";
import { GenesysDeploymentId, GenesysEnvironment } from "config";
import "./genesys-chat-button.css";

const GENESYS_SCRIPT_ID = "genesys-bootstrap-script";
const GENESYS_SCRIPT_SRC =
  "https://apps.mypurecloud.com/genesys-bootstrap/genesys.min.js";

// Snippet oficial "Bootstrap" de Genesys Cloud Messenger.
// No lo re-inyecta si ya existe (evita duplicados en re-renders/HMR).
function loadGenesysBootstrap(environment, deploymentId) {
  if (document.getElementById(GENESYS_SCRIPT_ID)) {
    return;
  }

  window._genesysJs = "Genesys";
  window.Genesys =
    window.Genesys ||
    function (...args) {
      (window.Genesys.q = window.Genesys.q || []).push(args);
    };
  window.Genesys.t = Date.now();
  window.Genesys.c = { environment, deploymentId };

  const script = document.createElement("script");
  script.id = GENESYS_SCRIPT_ID;
  script.async = true;
  script.src = GENESYS_SCRIPT_SRC;
  script.charset = "utf-8";
  document.head.appendChild(script);
}

const GenesysChatButton = () => {
  const [genesysReady, setGenesysReady] = useState(false);
  const [messengerOpen, setMessengerOpen] = useState(false);

  const isConfigured = Boolean(GenesysEnvironment && GenesysDeploymentId);

  useEffect(() => {
    if (!isConfigured) {
      return;
    }

    loadGenesysBootstrap(GenesysEnvironment, GenesysDeploymentId);

    window.Genesys("subscribe", "Messenger.ready", () => {
      setGenesysReady(true);
      // Ocultamos el launcher nativo de Genesys: usamos nuestro propio botón.
      window.Genesys("command", "Launcher.hide");
    });

    window.Genesys("subscribe", "Messenger.opened", () => {
      setMessengerOpen(true);
    });

    window.Genesys("subscribe", "Messenger.closed", () => {
      setMessengerOpen(false);
    });
  }, [isConfigured]);

  const handleClick = useCallback(() => {
    if (!genesysReady || typeof window.Genesys !== "function") {
      return;
    }
    window.Genesys("command", "Messenger.open");
  }, [genesysReady]);

  if (!isConfigured || messengerOpen) {
    return null;
  }

  return (
    <button
      type="button"
      className="genesys-chat-float"
      onClick={handleClick}
      disabled={!genesysReady}
      aria-label="Abrir chat en línea"
    >
      <svg
        aria-hidden="true"
        viewBox="0 0 24 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M12 2C6.48 2 2 5.94 2 10.8c0 2.66 1.36 5.04 3.5 6.64V22l3.7-2.04c.9.24 1.85.37 2.8.37 5.52 0 10-3.94 10-8.8S17.52 2 12 2z" />
      </svg>
    </button>
  );
};

export default GenesysChatButton;
